import { render, staticRenderFns } from "./GroupTag.vue?vue&type=template&id=e41d8cb6&"
import script from "./GroupTag.vue?vue&type=script&lang=ts&"
export * from "./GroupTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports